import React from 'react';
import EquipmentPlanner from './EquipmentPlanner';

function App() {
  return <EquipmentPlanner />;
}

export default App;

